import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  obtenerCarrerasActivas,
  obtenerEstudiantesDocsPendientesExcel,
  obtenerEstudiantesDocsPendientes,
} from "../../redux/solicitudesAdmSlice";
import { OrderTable } from "../../Components/OrderTable";
import Pagination from "./Paginacion";
import LoadingSpiner from "../../Components/LoadingSpiner";
import OperationStatus from "../../config/OperationStatus";
import { toast } from "react-toastify";

const columns = [
  { label: "Solicitud no.", accessor: "solicitudId", sortable: true },
  { label: "No. identificación", accessor: "dni", sortable: true },
  { label: "Nombre", accessor: "nombre", sortable: true },
  { label: "ID", accessor: "matricula", sortable: true },
  { label: "Carrera", accessor: "carrera", sortable: true },
  { label: "Teléfono", accessor: "telefono", sortable: false },
  { label: "Correo", accessor: "correo" },
  { label: "Documento pendiente", accessor: "documentoPendiente" },
  {
    label: "Fecha de vencimiento",
    accessor: "fechaVencimiento",
    sortable: true,
  },
];

export default function ListaEstudiantesDocumentosPendientes(props) {
  const [rowCount, setRowCount] = useState(15);
  const [currentPage, setCurrentPage] = useState(1);

  const [carrerasActivas, setCarrerasActivas] = useState([]);
  const [filtroCarrera, setFiltroCarrera] = useState(0);

  const dispatch = useDispatch();
  const busqueda = useRef();

  const { estudiantesDocsPendientes, loadingEstudiantesDocsPendientes } =
    useSelector((state) => state.solicitudesAdm);

  const handleResetPagination = () => {
    setCurrentPage(1);
    setRowCount(15);
  };

  useEffect(() => {
    handleResetPagination();
  }, [filtroCarrera]);

    const cargarEstudiantesPorCaracter = () => {
      handleResetPagination();
      dispatch(
        obtenerEstudiantesDocsPendientes({
          carrera: filtroCarrera,
          busqueda: busqueda.current.value,
          rowCount,
          page: currentPage,
        })
      );
    };

  const descargarArchivo = async () => {
    dispatch(
      obtenerEstudiantesDocsPendientesExcel({
        carrera: filtroCarrera,
        busqueda: busqueda.current.value,
      })
    ).then(({ payload }) => {
      if (payload.operationStatus === OperationStatus.SUCCESS) {
        toast.success(payload.message);
      } else {
        toast.error(payload.message);
      }
    });
  };

  useEffect(() => {
    dispatch(obtenerCarrerasActivas()).then((res) => {
      setCarrerasActivas(res.payload);
    });
  }, [dispatch]);

  useEffect(() => {
    dispatch(
      obtenerEstudiantesDocsPendientes({
        carrera: filtroCarrera,
        busqueda: busqueda.current.value,
        rowCount,
        page: currentPage,
      })
    );
  }, [currentPage, dispatch, rowCount, busqueda, filtroCarrera]);

  return (
    <main className="main-admin">
      <div className="main-admin-bar">
        <h2>Estudiantes con documentos pendientes</h2>

        <div className="header-admin-bar-items ml-auto">
          <div className="select-filter-section-ml-auto">
            <label hidden>Carrera:</label>
            <select
              value={filtroCarrera}
              onChange={(e) => setFiltroCarrera(e.target.value)}
            >
              <option hidden>Carrera</option>
              <option value={0}>Todas las carreras</option>
              {carrerasActivas?.map((a, i) => {
                return (
                  <option key={i} value={a.id}>
                    {a.carreraNombre}
                  </option>
                );
              })}
            </select>
          </div>
          <label hidden>Búsqueda</label>
          <input
            type="input"
            placeholder="Búsqueda"
            ref={busqueda}
            className="form-control"
            onChange={cargarEstudiantesPorCaracter}
          />
          <button className="search-button" onClick={() => descargarArchivo()}>
            <i className="material-icons"></i>
          </button>
        </div>
      </div>

      <div className="table-container relative-class">
        {loadingEstudiantesDocsPendientes && (
          <div className="loading-background">
            <LoadingSpiner
              show
              styles={{
                top: "45%",
                left: "50%",
                width: "50px",
                height: "50px",
                position: "absolute",
                borderWidth: "10px",
                borderStyle: "solid",
                backgroundColor: "rgba(0, 0, 0, 0.3)",
                borderColor: "rgb(27 78 147) rgb(0 0 0) rgb(0 0 0)",
                borderImage: "initial",
              }}
            />
          </div>
        )}
        {estudiantesDocsPendientes.result?.length > 0 ? (
          <>
            <OrderTable
              {...{ columns }}
              data={estudiantesDocsPendientes.result ?? []}
              clase="table-adm"
            />
          </>
        ) : (
          <div className="no-results-container">
            <img src={props.img} alt="Imagen sin resultados" />
            <h1>{props.noResultMessage}</h1>
          </div>
        )}
      </div>
      <Pagination
        rowCount={rowCount}
        currentPage={currentPage}
        onPageChange={setCurrentPage}
        onRowCountChange={setRowCount}
        totalPages={estudiantesDocsPendientes.pageCount ?? 1}
      />
    </main>
  );
}
